module.exports = __webpack_public_path__ + "img/product-ketang-qt-02.3982e4f2.png";